import { Component } from "react";
import { adminlimit, s3Link } from "../../Settings/Config";
import {
  showContaimerLoader,
  encodeValue,
  removeItem,
  showPageCount,
  showDate,
  calculateYMD,
  isSingleSelect,
  isEmpty,
  isNumber,
  removeChar,
  showLoader,
  hideLoader,
  apiDate,
  showAlert,
  showDateTime,
  validateDate,
  getDaysBetween,
  hasPermission, showHTMLText
} from "../../Settings/Settings";
import $ from "jquery";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Pagenation from "../../Layout/Pagenation";
import api from "../../../utils/axios";
import checkListList from "./prjoinchecklist.json";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { addDays } from "date-fns";
import { isNull } from "underscore";
const module = "candidatecontract";
const moduleName = "Contract";
const formStatus = [
  "Not Filled",
  "Section 1 Pending",
  "Section 1 Completed",
  "Section 1 Verified",
  "Section 2 Pending",
  "Section 2 Completed",
  "Section 2 Verified",
  "Section 3 Pending",
  "Section 3 Completed",
  "Section 3 Verified",
  "Section 4 Pending",
  "Section 4 Completed",
  "Fully Verified",
];
const formList = ["11", "14", "15", "41", "42", "44"];
const moduleID = 20;
// Older contracts saved contractSalary with these camelCase keys before the field names were
// aligned to the backend's PascalCase keys; fall back to them so old records still populate the form.
const salaryKeyAliases = {
  BasicWages: "basicWages",
  OvertimeWages: "fixedOvertimeAllowance",
  ShipboardAlawance: "shipboardAllowance",
  LeaveWages: "earnedLeaveWage",
  LeaveSubsistence: "leaveSubsistenceAllowance",
  UniformAllowance: "uniformAllowance",
  OwnersSpecialallowance: "ownersSpecialAllowance",
  MiscellaneousAllowance: "miscellaneousAllowance",
  OtherAllowance: "otherAllowance",
  EmloyerPF: "employerPF",
  EmployeePF: "employeePF",
};
const getSalaryValue = (contractSalary, key) => {
  if (!contractSalary) return "";
  if (contractSalary[key] !== undefined && contractSalary[key] !== null && contractSalary[key] !== "") {
    return contractSalary[key];
  }
  const alias = salaryKeyAliases[key];
  return (alias && contractSalary[alias]) || "";
};

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      checkListList: checkListList,
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      allowToAddNew: false,
      name: "",
      status: "",
      editID: "",
      postdata: {
        rank: "",
        company: "",
        vslName: "",
        vesselType: "",
        sign_on_port: "",
        sign_on: "",
        sign_on_dg: "",
        emigrate_number: "",
        wage_start: "",
        eoc: "",
        wages: "",
        currency: "",
        wages_types: "",
        sign_off: "",
        sign_off_dg: "",
        sign_off_port: "",
        reason_for_sign_off: "",
        contract_document: "",
        contract_aoa: "",
        aoa_number: "",
        sign_on_dg_file: "",
        sign_off_dg_file: "",
        contractExtensionFile: "",
        contractKARCOCertificate: "",
        contractAppraisalReportFile: "",
        contractOff11: "",
        contractExtension: "",
        contractRevisionCategory: "",
        contractRevisionRequestedBy: "",
        contractExtensionDate: "",
        contractExtensionDays: "",
        contractRevisionRemarks: "",
        contractPrejoinCurrent: 0,
      },
      contactID: "",
      prejoinFormData: [],
      prejoinCurrent: 0,
      viewDocumentTitle: "",
      viewDocumentFile: "",
      salaryContractID: "",
      salaryData: {
        BasicWages: "",
        OvertimeWages: "",
        ShipboardAlawance: "",
        LeaveWages: "",
        LeaveSubsistence: "",
        UniformAllowance: "",
        OwnersSpecialallowance: "",
        MiscellaneousAllowance: "",
        OtherAllowance: "",
        EmloyerPF: "",
        EmployeePF: "",
      },
      salaryErrors: {
        BasicWages: "",
      },
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
  }
  loadVessl() {
    api
      .get(`vessel/activedropdown?companyID=${this.state.postdata.company?.value || ""}`)
      .then((res) => {
        if (res.data.status === "ok") {
          let result = res.data.result;
          this.setState({ vesselList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  searchList(e) {
    e.preventDefault();
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        name: "",
        status: "",
        currentPage: 1,
      },
      () => {
        this.loadList(1);
      },
    );
  }
  loadList(offset) {
    this.setState({ loading: true });
    let addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (this.state.status !== null && Object.keys(this.state.status).length > 0) {
      addParams += "&status=" + this.state.status.value;
    }

    try {
      api
        .get(`${module}?limit=${this.state.pageLimit.value}&offset=${offset}&candidateId=${this.props.candidateID}${addParams}`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ listdata: res.data.result, loading: false, totalRecords: res.data.totalRecords, totalPage: res.data.totalPages, allowToAddNew: res.data.allowToAddNew });
          }
        })
        .catch((err) => {
          this.setState({ loading: false, allowToAddNew:true, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
        });
    } catch (e) {
      this.setState({ loading: false, allowToAddNew:true, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
    }
  }
  edit(editID, e) {
    e.preventDefault();
    this.setState({ editID: editID }, () => {
      this.resetFrom();
      
      api
        .get(`${module}/detail/${encodeValue(editID)}`)
        .then((res) => {
          if (res.data.status === "ok") {
            $("#addNewContract").trigger("click");
            const result = res.data.result;
            const company = this.props.companyList.find((c) => c.value === parseInt(result.company));

            const contractExtForm = result?.contractExtForms ?? "";
            let contractExtForms = contractExtForm !== "" && contractExtForm !== null ? JSON.parse(contractExtForm) : [];
            const index11 = contractExtForms.findIndex((item) => item.type === "Form 11");
            const index14 = contractExtForms.findIndex((item) => item.type === "Form 14");
            const index15 = contractExtForms.findIndex((item) => item.type === "Form 15");
            const index41 = contractExtForms.findIndex((item) => item.type === "Form 41");
            const index42 = contractExtForms.findIndex((item) => item.type === "Form 42");
            const index44 = contractExtForms.findIndex((item) => item.type === "Form 44");

            this.setState(
              {
                postdata: {
                  rank: result.rank,
                  company: company,
                  vslName: result.vslName,
                  vesselType: result.vesselType !== "" && result.vesselType !== null ? { label: result.vesselType, value: result.vesselType } : "",
                  sign_on_port: result.sign_on_port,
                  sign_on: validateDate(result.sign_on),
                  sign_on_dg: validateDate(result.sign_on_dg),
                  emigrate_number: result.emigrate_number || "",
                  wage_start: validateDate(result.wage_start),
                  eoc: validateDate(result.eoc),
                  wages: result.wages || "",
                  currency: result.currency !== "" && result.currency !== null ? { label: result.currency, value: result.currency } : "",
                  wages_types: result.wages_types !== "" && result.wages_types !== null ? { label: result.wages_types, value: result.wages_types } : "",
                  sign_off: validateDate(result.sign_off),
                  sign_off_dg: validateDate(result.sign_off_dg),
                  sign_off_port: result.sign_off_port,
                  reason_for_sign_off: result.reason_for_sign_off || "",
                  contract_document: result.documents ?? "",
                  contract_aoa: result.aoa ?? "",
                  aoa_number: result.aoa_number ?? "",
                  sign_on_dg_file: result.sign_on_dg_file ?? "",
                  sign_off_dg_file: result.sign_off_dg_file ?? "",
                  contractExtensionFile: result.contractExtensionFile ?? "",
                  contractKARCOCertificate: result.contractKARCOCertificate ?? "",
                  contractAppraisalReportFile: result.contractAppraisalReportFile ?? "",
                  contractOff11: index11 >= 0 ? contractExtForms[index11].pathFileName : "",
                  contractOff14: index14 >= 0 ? contractExtForms[index14].pathFileName : "",
                  contractOff15: index15 >= 0 ? contractExtForms[index15].pathFileName : "",
                  contractOff41: index41 >= 0 ? contractExtForms[index41].pathFileName : "",
                  contractOff42: index42 >= 0 ? contractExtForms[index42].pathFileName : "",
                  contractOff44: index44 >= 0 ? contractExtForms[index44].pathFileName : "",
                  contractExtension: result.contractExtension !== "" ? { label: result.contractExtension, value: result.contractExtension } : "",
                  contractRevisionCategory: result.contractRevisionCategory !== "" ? { label: result.contractRevisionCategory, value: result.contractRevisionCategory } : "",
                  contractRevisionRequestedBy: result.contractRevisionRequestedBy !== "" ? { label: result.contractRevisionRequestedBy, value: result.contractRevisionRequestedBy } : "",
                  contractExtensionDate: validateDate(result.contractExtensionDate),
                  contractExtensionDays: result.contractExtensionDays ?? "",
                  contractRevisionRemarks: result.contractRevisionRemarks ?? "",
                  contractPrejoinCurrent: result.contractPrejoinCurrent ?? 0,
                },
              },
              () => {
                this.loadVessl();
              },
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        () => {
          this.loadList(value);
        },
      );
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }
  viewFile(viewDocumentFile, viewDocumentTitle, e) {
    e.preventDefault();
  
    window.open(`${s3Link}${viewDocumentFile}`, '_blank');
    /* this.setState({ viewDocumentFile, viewDocumentTitle }, () => {
      $("#addNewContract").trigger("click");
    }); */
  }
  closePopup() {
    this.setState({ viewDocumentFile: "", viewDocumentTitle: "" }, () => {
      setTimeout(() => {
        this.resetFrom();
      }, 1000);
    });
  }
  resetFrom() {
    this.setState({
      restForm: true,
      postdata: {
        rank: "",
        company: "",
        vslName: "",
        vesselType: "",
        sign_on_port: "",
        sign_on: "",
        sign_on_dg: "",
        emigrate_number: "",
        wage_start: "",
        eoc: "",
        wages: "",
        currency: "",
        wages_types: "",
        sign_off: "",
        sign_off_dg: "",
        sign_off_port: "",
        reason_for_sign_off: "",
        contract_document: "",
        contract_aoa: "",
        aoa_number: "",
        sign_on_dg_file: "",
        sign_off_dg_file: "",
        contractExtensionFile: "",
        contractKARCOCertificate: "",
        contractAppraisalReportFile: "",
        contractOff11: "",
        contractOff14: "",
        contractOff15: "",
        contractOff41: "",
        contractOff42: "",
        contractOff44: "",
        contractExtension: "",
        contractRevisionCategory: "",
        contractRevisionRequestedBy: "",
        contractExtensionDate: "",
        contractExtensionDays: "",
        contractRevisionRemarks: "",
        contractPrejoinCurrent: 0,
      },
    });
  }

  handleSubmit = () => {
    showLoader("submit_contract_frm");
    const postData = this.state.postdata;

    const postObject = {
      candidateId: this.props.candidateID,
      rank: postData.rank?.value || "",
      company: postData.company?.value || "",
      vslName: postData.vslName?.value || "",
      vesselType: postData.vesselType?.value || "",
      sign_on_port: postData.sign_on_port?.value || "",
      sign_on: apiDate(postData.sign_on),
      sign_on_dg: apiDate(postData.sign_on_dg),
      eoc: apiDate(postData.eoc),
      wage_start: apiDate(postData.wage_start),
      wages: postData.wages,
      currency: postData.currency?.value || "",
      wages_types: postData.wages_types?.value || "",
      aoa_number: postData?.aoa_number || "",
      emigrate_number: postData?.emigrate_number || "",
      sign_off: apiDate(postData?.sign_off),
      sign_off_dg: apiDate(postData?.sign_off_dg),
      sign_off_port: postData?.sign_off_port?.value || "",
      reason_for_sign_off: postData?.reason_for_sign_off || "",
      contractExtension: postData?.contractExtension?.value || "",
      contractRevisionCategory: postData?.contractRevisionCategory?.value || "",
      contractRevisionRequestedBy: postData?.contractRevisionRequestedBy?.value || "",
      contractExtensionDate: apiDate(postData?.contractExtensionDate),
      contractExtensionDays: postData?.contractExtensionDays || "",
      contractRevisionRemarks: postData?.contractRevisionRemarks || "",
    };

    const formPayload = new FormData();
    let error = "";
    const fileInput = document.getElementById("contract_document");
    const file = fileInput?.files?.[0];
    if (file) {
      if (file.type !== "application/pdf") {
        error += "Document PDF only allowed";
      } else {
        formPayload.append("documentFiles", file);
      }
    }

    const contract_aoa = document.getElementById("contract_aoa");
    const aoafile = contract_aoa?.files?.[0];
    if (aoafile) {
      if (aoafile.type !== "application/pdf") {
        error += "Document PDF only allowed\n";
      } else {
        formPayload.append("aoadocument", aoafile);
      }
    }

    const sign_on_dg_file = document.getElementById("sign_on_dg_file");
    const signondgfile = sign_on_dg_file?.files?.[0];
    if (signondgfile) {
      if (signondgfile.type !== "application/pdf") {
        error += "Document PDF only allowed\n";
      } else {
        formPayload.append("signondgfile", signondgfile);
      }
    }

    const sign_off_dg_file = document.getElementById("sign_off_dg_file");
    const signoffdgfile = sign_off_dg_file?.files?.[0];
    if (signoffdgfile) {
      if (signoffdgfile.type !== "application/pdf") {
        error += "Document PDF only allowed\n";
      } else {
        formPayload.append("signoffdgfile", signoffdgfile);
      }
    }

    const contractExtensionFile = document.getElementById("contractExtensionFile");
    const contractExtensionFile_ = contractExtensionFile?.files?.[0];
    if (contractExtensionFile_) {
      if (contractExtensionFile_.type !== "application/pdf") {
        error += "Document PDF only allowed\n";
      } else {
        formPayload.append("contractExtensionFile", contractExtensionFile_);
      }
    }

    const contractKARCOCertificate = document.getElementById("contractKARCOCertificate");
    const contractKARCOCertificate_ = contractKARCOCertificate?.files?.[0];
    if (contractKARCOCertificate_) {
      if (contractKARCOCertificate_.type !== "application/pdf") {
        error += "Document PDF only allowed\n";
      } else {
        formPayload.append("contractKARCOCertificate", contractKARCOCertificate_);
      }
    }

    const contractAppraisalReportFile = document.getElementById("contractAppraisalReportFile");
    const contractAppraisalReportFile_ = contractAppraisalReportFile?.files?.[0];
    if (contractAppraisalReportFile_) {
      if (contractAppraisalReportFile_.type !== "application/pdf") {
        error += "Document PDF only allowed\n";
      } else {
        formPayload.append("contractAppraisalReportFile", contractAppraisalReportFile_);
      }
    }

    for (const formNo of formList) {
      const contractOff = document.getElementById(`contractOff${formNo}`);
      const contractOff_ = contractOff?.files?.[0];
      if (contractOff_) {
        if (contractOff_.type !== "application/pdf") {
          error += "Document PDF only allowed\n";
        } else {
          formPayload.append(`contractOff${formNo}`, contractOff_);
        }
      }
    }

    if (error !== "") {
      showAlert("Error", error, "error");
      return false;
    }
    Object.keys(postObject).forEach((key) => {
      formPayload.append(key, postObject[key]);
    });

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${encodeValue(this.state.editID)}`;
      method = "put";
    }
   
    api[method](post_url, formPayload)
      .then((res) => {
        hideLoader("submit_contract_frm");
        $(".btn-close").trigger("click");
        const errMsg = res.data.message;
        if (res.data.status === "ok") {
          this.props.sateValChange("loadCandidateDetails", "Yes");
          this.setState({editID: ""})
          showAlert("Success", errMsg, "success", "No");
          this.loadList(1);
          console.log(this.props, 'this.propsthis.props')
          
          setTimeout(() => {
            this.resetFrom();
          }, 1000);
        }
      })
      .catch((err) => {
        hideLoader("submit_contract_frm");
        const errMsg = err.response?.data?.message || err?.message;
        showAlert("Error", errMsg, "error", "No");
        console.error(err);
      });
  };

  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }), () => {
      if (field === "company") {
        this.loadVessl();
      } else if (field === "contractExtensionDate") {
        const contractExtensionDate = this.state.postdata.contractExtensionDate;
        const eoc = this.state.postdata.eoc;
        const contractExtensionDays = getDaysBetween(eoc, contractExtensionDate);
        this.setState(update(this.state, { postdata: { contractExtensionDays: { $set: contractExtensionDays } } }));
      }
    });
  };

  editSalary(item, e) {
    e.preventDefault();
    const contractSalary_ = item.contractSalary || '';
    const contractSalary = (contractSalary_!=="" && contractSalary_!==null)?JSON.parse(contractSalary_):'';
    this.setState(
      {
        salaryContractID: item.id,
        salaryData: {
          BasicWages: getSalaryValue(contractSalary, "BasicWages"),
          OvertimeWages: getSalaryValue(contractSalary, "OvertimeWages"),
          ShipboardAlawance: getSalaryValue(contractSalary, "ShipboardAlawance"),
          LeaveWages: getSalaryValue(contractSalary, "LeaveWages"),
          LeaveSubsistence: getSalaryValue(contractSalary, "LeaveSubsistence"),
          UniformAllowance: getSalaryValue(contractSalary, "UniformAllowance"),
          OwnersSpecialallowance: getSalaryValue(contractSalary, "OwnersSpecialallowance"),
          MiscellaneousAllowance: getSalaryValue(contractSalary, "MiscellaneousAllowance"),
          OtherAllowance: getSalaryValue(contractSalary, "OtherAllowance"),
          EmloyerPF: getSalaryValue(contractSalary, "EmloyerPF"),
          EmployeePF: getSalaryValue(contractSalary, "EmployeePF"),
        },
        salaryErrors: {
          BasicWages: "",
        },
      },
      () => {
        $("#salaryModalTrigger").trigger("click");
      },
    );
  }
  handleSalaryChange = (field, value) => {
    this.setState(update(this.state, { salaryData: { [field]: { $set: value } }, salaryErrors: { [field]: { $set: "" } } }));
  };
  closeSalaryPopup() {
    this.setState({
      salaryContractID: "",
      salaryData: {
        BasicWages: "",
        OvertimeWages: "",
        ShipboardAlawance: "",
        LeaveWages: "",
        LeaveSubsistence: "",
        UniformAllowance: "",
        OwnersSpecialallowance: "",
        MiscellaneousAllowance: "",
        OtherAllowance: "",
        EmloyerPF: "",
        EmployeePF: "",
      },
      salaryErrors: {
        BasicWages: "",
      },
    });
  }
  saveSalary = () => {
    const BasicWagesError = isEmpty(this.state.salaryData.BasicWages) || isNumber(this.state.salaryData.BasicWages);
    if (BasicWagesError) {
      this.setState({ salaryErrors: { BasicWages: BasicWagesError } });
      return;
    }
    showLoader("submit_salary_frm");
    const postData = {
      salaryData:JSON.stringify(this.state.salaryData)
    };
    api
      .put(`${module}/updatesalary/${encodeValue(this.props.candidateID)}/${encodeValue(this.state.salaryContractID)}`, postData)
      .then((res) => {
        hideLoader("submit_salary_frm");
        const errMsg = res.data.message;
        if (res.data.status === "ok") {
          $("#salaryModalClose").trigger("click");
          showAlert("Success", errMsg, "success", "No");
          this.loadList(this.state.currentPage);
          this.closeSalaryPopup();
        }
      })
      .catch((err) => {
        hideLoader("submit_salary_frm");
        const errMsg = err.response?.data?.message || err?.message;
        showAlert("Error", errMsg, "error", "No");
        console.error(err);
      });
  };
  editCheckList(contactID, prejoinFormData, prejoinCurrent, e) {
    e.preventDefault();
    $("#accordion1 .accordion-toggle").addClass("collapsed");
    $("#accordion1 .panel-collapse").removeClass("show");
    const prejoinFormData_ = prejoinFormData !== "" && prejoinFormData !== null ? JSON.parse(prejoinFormData) : [];
    this.setState({ contactID, finalResult: checkListList, prejoinFormData: prejoinFormData_, prejoinCurrent }, () => {
      $("#CheckListContract").trigger("click");
      if (prejoinCurrent === 8) {
        $("#accordion1 .accordion-toggle").removeClass("collapsed");
        $("#accordion1 .panel-collapse").addClass("show");
      } else {
        $("#accordion1 .accordion-toggle").last().removeClass("collapsed");
        $("#accordion1 .panel-collapse").last().addClass("show");
      }
    });
  }
  handleRadioChange(sectionId, questionId, updateValue) {
    this.updatePrejoinFormData(sectionId, questionId, "available", updateValue);
  }
  handleTextChange(sectionId, questionId, e) {
    const value = e.target.value;
    this.updatePrejoinFormData(sectionId, questionId, "remarks", value);
  }
  handleVerify(sectionId, e) {
    const checked = e.target.checked;
    this.updatePrejoinFormData(sectionId, "", "verify", checked);
  }

  updatePrejoinFormData = (sectionId, questionId, updateType, updateValue) => {
    const prevData = this.state.prejoinFormData;
    const sectionIndex = prevData.findIndex((section) => section.id === sectionId);
    let updatedData = [...prevData];
    if (sectionIndex !== -1) {
      // section exists
      const section = updatedData[sectionIndex];
      if (questionId !== "") {
        const questionIndex = section.questions.findIndex((q) => q.id === questionId);
        if (questionIndex !== -1) {
          // question exists → update
          section.questions[questionIndex] = {
            ...section.questions[questionIndex],
            [updateType]: updateValue,
          };
        } else {
          // question does not exist → add
          section.questions.push({
            id: questionId,
            [updateType]: updateValue,
          });
        }
      } else {
        section[updateType] = updateValue;
      }
    } else {
      // section does not exist → create new section and add question
      updatedData.push({
        id: sectionId,
        title: sectionId, // optional, you can change
        questions: [
          {
            id: questionId,
            [updateType]: updateValue,
          },
        ],
      });
    }
    this.setState({ prejoinFormData: updatedData }, () => {
      this.checkPrejoinForm();
    });
  };
  checkPrejoinForm(saveType = "save") {
    const prevData = this.state.prejoinFormData;
    const saveForm = this.state.saveForm;

    let startLoop = 0;
    let error = 0;
    const checkListList = this.state.checkListList.map((item, mindex) => {
      let currentCompletd = false;
      const sectionIndex = prevData.findIndex((section) => section.id === item.id);
      let verified = false;
      if (sectionIndex >= 0) {
        currentCompletd = prevData[sectionIndex]?.completed || false;
        verified = prevData[sectionIndex]?.verified || false;
        if (!verified && currentCompletd) {
          currentCompletd = false;
        }
      }

      if (startLoop === 0 && !currentCompletd) {
        startLoop++;
        let questions = item.questions.map((qItem) => {
          let existQuestion = "";
          if (sectionIndex !== -1) {
            // section exists
            const section = prevData[sectionIndex];
            const questionIndex = section.questions.findIndex((q) => q.id === qItem.id);
            if (questionIndex !== -1) {
              // question exists → update
              existQuestion = {
                ...section.questions[questionIndex],
              };
            }
          }

          if (existQuestion?.available === "Yes") {
            qItem.error = false;
          } else {
            if (existQuestion?.available === "No") {
              if (!existQuestion?.remarks || existQuestion?.remarks === "") {
                if (saveForm && saveType === "complete") {
                  qItem.error = true;
                  error++;
                }
              } else {
                if (saveForm) {
                  qItem.error = false;
                }
              }
            } else {
              if (saveForm && saveType === "complete") {
                qItem.error = true;
                error++;
              }
            }
          }
          return qItem;
        });
        item.questions = questions;
        /* if([2, 5, 8, 11].indexOf(this.state.prejoinCurrent)>=0) {
          console.log(item, 'itemitemitem')
          const verify_ = item?.verify || false;

          if(verify_===false && saveType==='complete') {
            item.error = true;
            error++;
          }else {
            item.error = false;
          }
        } */

        return item;
      } else {
        return item;
      }
    });
    this.setState({ finalResult: checkListList });
    return error;
  }

  savePrejoinForm = async (saveType) => {
    this.setState({ saveForm: true }, async () => {
      const checkErrorStatus = await this.checkPrejoinForm(saveType);
      console.log(checkErrorStatus, "checkErrorStatuscheckErrorStatus");
      if (!checkErrorStatus) {
        /*  console.log('aaaaaaaaaaa')
        return false; */
        const prejoinFormData = this.state.prejoinFormData;
        const finalData = prejoinFormData.map((item) => {
          const verified = item?.verified || false;
          const completed = item?.completed || false;
          if (!verified && !completed) {
            item.newcompleted = true;
          } else if (!verified) {
            item.newverified = true;
          }
          return item;
        });
        const postDate = {
          prejoinFormData: JSON.stringify(finalData),
          saveType,
        };
        showLoader("saveJoinForm");
        api
          .put(`${module}/updateprejoinform/${encodeValue(this.props.candidateID)}/${encodeValue(this.state.contactID)}`, postDate)
          .then((res) => {
            const errMsg = res.data.message;
            if (res.data.status === "ok") {
              this.setState({ saveForm: false, prejoinFormData: [] }, () => {
                this.loadList(this.state.currentPage);
                $(".btn-close").trigger("click");
                showAlert("Success", errMsg, "success", "No");
              });
            }
            hideLoader("saveJoinForm");
          })
          .catch((err) => {
            const errMsg = err.response.data?.message || err?.message;
            showAlert("Error", errMsg, "error", "No");
            hideLoader("saveJoinForm");
            console.error(err);
          });
      }
    });
  };

  render() {
    const prevData_ = this.state.prejoinFormData;
    return (
      <div className="main-container container-fluid mx-3">
        <div className="page-header">
          <h1 className="page-title">Contracts</h1>
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                {hasPermission(moduleID, "add") && (
                  <button
                    className={`btn btn-sm btn-success badge mx-4 ${!this.state.allowToAddNew ? "hidden" : ""}`}
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#contractmodal"
                    data-backdrop="static"
                    data-keyboard="false"
                    id="addNewContract"
                  >
                    <i className="fa fa-plus"></i> Add New
                  </button>
                )}
                <button
                  className="btn btn-sm btn-success badge mx-4 hidden"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#checkListmodal"
                  data-backdrop="static"
                  data-keyboard="false"
                  id="CheckListContract"
                >
                  <i className="fa fa-plus"></i> Join Form
                </button>
                <button
                  className="btn btn-sm btn-success badge mx-4 hidden"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#salarymodal"
                  data-backdrop="static"
                  data-keyboard="false"
                  id="salaryModalTrigger"
                >
                  <i className="fa fa-plus"></i> Salary
                </button>
              </li>
            </ol>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-row">
                  <div className="col-md-3">
                    <input type="text" className="form-control" placeholder={"Search keyword"} name="name" onChange={this.handleChangeText} value={this.state.name} />
                  </div>
                  <div className="col-md-3">
                    <a href="/" className="btn btn-primary" onClick={this.searchList.bind(this)}>
                      Search
                    </a>
                    <a href="/" className="btn btn-secondary offset-1" onClick={this.resetSearch.bind(this)}>
                      Reload
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              {this.state.loading ? (
                showContaimerLoader()
              ) : (
                <div>
                  <div className="card-header">
                    {parseInt(this.state.totalPage) > 0 && showPageCount(moduleName, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead className="table-primary">
                          <tr className="contract-list-heading">
                            {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && (
                              <th className="text-center" rowSpan={2}>
                                Actions{" "}
                              </th>
                            )}
                            <th rowSpan={2}>S.No.</th>
                            <th rowSpan={2}>Form Status</th>
                            <th rowSpan={2}>Rank</th>
                            <th rowSpan={2}>Company</th>
                            <th rowSpan={2}>VSL Name</th>
                            <th rowSpan={2}>VSL Type</th>
                            <th rowSpan={2}>Sign On Port</th>
                            <th rowSpan={2}>Sign On Date</th>
                            <th rowSpan={2}>DG Sign ON Date</th>
                            <th rowSpan={2}>Emigrate No <br/> on FORM-1</th>
                            <th rowSpan={2}>Wages Starts <br/>From</th>
                            <th rowSpan={2}>AOA No.</th>
                            <th rowSpan={2}>End of <br/>Contract Date</th>
                            <th rowSpan={2}>Duration of <br/>Contract</th>
                            <th rowSpan={2}>Wages</th>
                            <th rowSpan={2}>Wages Type</th>
                            <th rowSpan={2}>Sign Off Date</th>
                            <th rowSpan={2}>DG Sign Off <br/>Date</th>
                            <th rowSpan={2}>Sign Off Port</th>
                            <th rowSpan={2}>Sign Off Reason</th>
                            <th rowSpan={2}>Total Days <br/>Onboard</th>
                            <th rowSpan={2}>Contract <br/>Extension</th>
                            <th rowSpan={2}>Rev/Ext</th>
                            <th rowSpan={2}>Requested By</th>
                            <th rowSpan={2}>Extension Date</th>
                            <th rowSpan={2}>Extension Remakrs</th>
                            <th rowSpan={2}>Extension Days</th>
                            <th rowSpan={2}>Actual Stay <br/>Period onboard</th>
                            <th rowSpan={2}>Upload ”DG<br/> FORM-1-S/On"</th>
                            <th rowSpan={2}>Upload COE/SEA</th>
                            <th rowSpan={2}>Upload AOA</th>
                            <th rowSpan={2}>Upload ”DG FORM <br/>at S/Off”</th>
                            <th rowSpan={2}>Extension Document</th>
                            <th colSpan={8}>Other Supporting<br/> documents</th>
                            <th rowSpan={2}>After S/OFF - <br/>Available Re-Join<br/> Date"</th>
                          </tr>
                          <tr className="contract-list-heading">
                            <th>Upload OFF-11 “Seafarer<br/> Medical Fitness <br/>Self Declaration”</th>
                            <th>Upload OFF-14 “Officer<br/> Briefing Checklist”</th>
                            <th>Upload OFF-15 “Pre<br/> Engagement Briefing Checklist<br/> For Off Crew”</th>
                            <th>Upload OFF-41 <br/>“Pre Joining Checklist”</th>
                            <th>Upload OFF-42 “Next<br/> Of Kin Declaration Pan<br/> Bank Details”</th>
                            <th>Upload OFF-44 “Pre<br/> Employment Declaration”</th>
                            <th>Upload KARCO<br/> Test Certificate</th>
                            <th>Upload Appraisal<br/> Report</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.listdata.length > 0 ? (
                            this.state.listdata.map((item, index) => {
                              const contractExtForms = item.contractExtForms !== "" && item.contractExtForms !== null ? JSON.parse(item.contractExtForms) : [];

                              const form11 = "Form 11";
                              const form11result = contractExtForms.length > 0 ? contractExtForms.find((item) => item.type === form11) || "" : "";

                              const form14 = "Form 14";
                              const form14result = contractExtForms.length > 0 ? contractExtForms.find((item) => item.type === form14) || "" : "";

                              const form15 = "Form 15";
                              const form15result = contractExtForms.length > 0 ? contractExtForms.find((item) => item.type === form15) || "" : "";

                              const form41 = "Form 41";
                              const form41result = contractExtForms.length > 0 ? contractExtForms.find((item) => item.type === form41) || "" : "";

                              const form42 = "Form 42";
                              const form42result = contractExtForms.length > 0 ? contractExtForms.find((item) => item.type === form42) || "" : "";

                              const form44 = "Form 44";
                              const form44result = contractExtForms.length > 0 ? contractExtForms.find((item) => item.type === form44) || "" : "";

                              const contractPrejoinCurrent = item?.contractPrejoinCurrent || 0;
                              const contractExtensionDays = item?.contractExtensionDays ?? ""
                              return (
                                <tr key={index} className={`${isNull(item.sign_off) || item.sign_off === "1970-01-01" || item.sign_off === "" ? "bg-current text-white" : ""}`}>
                                  <td className="text-center text-nowrap" valign="top">
                                    {hasPermission(moduleID, "edit") && (
                                      <a href="/" onClick={this.edit.bind(this, item.id)} className="me-2">
                                        <i className="fa fa-pencil-square-o"></i>
                                      </a>
                                    )}
                                    {hasPermission(moduleID, "delete") && (
                                      <a href="/" className="delete_record me-2" onClick={this.removeItem.bind(this, encodeValue(item.id))}>
                                        <i className="fa fa-trash "></i>
                                      </a>
                                    )}
                                    <a href="/" onClick={this.editCheckList.bind(this, item.id, item.contractPrejoinForm, contractPrejoinCurrent || 0)} data-tooltip-id={`my-tooltip${index}`} className="me-2">
                                      <i
                                        className={`fa fa-check-square-o ${contractPrejoinCurrent === 12 ? "text-success" : contractPrejoinCurrent === 0 ? "" : "text-warning"}`}
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                    <Tooltip
                                      id={`my-tooltip${index}`}
                                      className={`bg-${contractPrejoinCurrent === 12 ? "success" : contractPrejoinCurrent === 0 ? "" : "warning"} text-white`}
                                      place="right"
                                      clickable
                                      render={() => <div>{formStatus[item.contractPrejoinCurrent || 0]}</div>}
                                    />
                                    <a href="/" onClick={this.editSalary.bind(this, item)} data-tooltip-id={`salary-tooltip${index}`}>
                                      <i className="fa fa-usd" aria-hidden="true"></i>
                                    </a>
                                    <Tooltip id={`salary-tooltip${index}`} place="right" render={() => <div>Salary Details</div>} />
                                  </td>
                                  <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                  <td>{formStatus[item.contractPrejoinCurrent || 0]}</td>

                                  <td>{item.rank}</td>
                                  <td>{item.company_name}</td>
                                  <td>{item.vesselName}</td>
                                  <td>{item.vesselType}</td>
                                  <td>{item.signONPortName}</td>
                                  <td>{showDate(item.sign_on)}</td>
                                  <td>{showDate(item.sign_on_dg)}</td>
                                  <td>{item.emigrate_number}</td>
                                  <td>{showDate(item.wage_start)}</td>
                                  <td>{item.aoa_number}</td>
                                  <td>{showDate(item.eoc)}</td>
                                  <td>{calculateYMD(item.sign_on, item.eoc)}</td>
                                  <td>
                                    {item.currency}
                                    {item.wages}
                                  </td>
                                  <td>{item.wages_types}</td>
                                  <td>{showDate(item.sign_off)}</td>
                                  <td>{showDate(item.sign_off_dg)}</td>
                                  
                                  <td>{item?.signOFFPortName || ""}</td>
                                  <td>{item.reason_for_sign_off}</td>
                                  <td>{calculateYMD(item.sign_on, item.sign_off || new Date())}</td>
                                  <td>{item.contractExtension}</td>
                                  <td>{item?.contractRevisionCategory || ""}</td>
                                  <td>{item?.contractRevisionRequestedBy || ""}</td>
                                  <td>{showDate(item?.contractExtensionDate || "")}</td>
                                  <td>{item?.contractRevisionRemarks || ""}</td>
                                  <td>{(contractExtensionDays!=="" && contractExtensionDays!==null)?parseFloat(contractExtensionDays).toFixed(0):''}</td>
                                  <td></td>
                                  <td className="text-center">
                                    {item.sign_on_dg_file !== "" && item.sign_on_dg_file !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, `contract/${item.sign_on_dg_file}`, 'View Sign On DG')}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {item.documents !== "" && item.documents !== null && (
                                      <a href="/"  onClick={this.viewFile.bind(this, `contract/${item.documents}`, 'View Contract Document')}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {item.aoa !== "" && item.aoa !== null && (
                                      <a href="/"  onClick={this.viewFile.bind(this, `contract/${item.aoa}`, 'View AOA Document')}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {item.sign_off_dg_file !== "" && item.sign_off_dg_file !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, `contract/${item.sign_off_dg_file}`, 'View Sign Off DG')}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {item.contractExtensionFile !== "" && item.contractExtensionFile !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, `contract/${item.contractExtensionFile}`, 'View Extension Contract')}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {form11result !== "" && form11result !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, `contract/${form11result.pathFileName}`, 'View Upload OFF-11 “Seafarer Medical Fitness Self Declaration”')} >
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {form14result !== "" && form14result !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, `contract/${form14result.pathFileName}`, 'View Upload OFF-14 “Officer Briefing Checklist”')}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {form15result !== "" && form15result !== null && (
                                      <a href="/"  onClick={this.viewFile.bind(this, `contract/${form15result.pathFileName}`, 'View Upload OFF-15 “Pre Engagement Briefing Checklist For Off Crew”')}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {form41result !== "" && form41result !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, `contract/${form41result.pathFileName}`, 'View Upload OFF-41 “Pre Joining Checklist”')}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {form42result !== "" && form42result !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, `contract/${form42result.pathFileName}`, 'View Upload OFF-42 “Next Of Kin Declaration Pan Bank Details”')}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {form44result !== "" && form44result !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, `contract/${form44result.pathFileName}`, 'View Upload OFF-44 “Pre Employment Declaration”')}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {item.contractKARCOCertificate !== "" && item.contractKARCOCertificate !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, `contract/${item.contractKARCOCertificate}`, 'View Upload KARCO Test Certificate')}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {item.contractAppraisalReportFile !== "" && item.contractAppraisalReportFile !== null && (
                                      <a href="/" onClick={this.viewFile.bind(this, `contract/${item.contractAppraisalReportFile}`, 'View Upload Appraisal Report')}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                  <td>{showDate(item?.contractAfterSignOFFReJoinDate || "")}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={13}>
                                No {moduleName} Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {parseInt(this.state.totalPage) > 1 && (
                      <Pagenation
                        params={{
                          totalRecords: this.state.totalRecords,
                          totalPage: this.state.totalPage,
                          currentPage: this.state.currentPage,
                        }}
                        sateValChange={this.sateValChange}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="modal fade" id="contractmodal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{this.state.viewDocumentFile !== "" ? `${this.state.viewDocumentTitle}` : this.state.editID !== "" ? "Update Contract" : "Add New Contract"}</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              {this.state.viewDocumentFile !== "" ? (
                <div>
                  {<iframe src={`${s3Link}${this.state.viewDocumentFile}`} width="100%" height="500px" title="View Doc"></iframe>}
                  <div className="modal-footer">
                    <button className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                      Close
                    </button>
                  </div>
                </div>
              ) : (
                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  vesselList={this.state.vesselList}
                  documentTypeList={this.state.documentTypeList}
                  restForm={this.state.restForm}
                  sateValChange={this.sateValChange}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  editID={this.state.editID}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                  }}
                />
              )}
            </div>
          </div>
        </div>

        <div className="modal fade" id="checkListmodal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Check List</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                {this.state.checkListList.map((item, mIndex) => {
                  let prevSectionVerified = false;
                  let currentCompletd = false;
                  let currentVerified = false;
                  const sectionIndex = prevData_.findIndex((section) => section.id === item.id);
                  const prevsectionIndex = mIndex > 0 ? prevData_.findIndex((section) => section.id === this.state.checkListList[mIndex - 1].id) : "";
                  if (sectionIndex >= 0) {
                    currentCompletd = prevData_[sectionIndex]?.completed || false;
                    currentVerified = prevData_[sectionIndex]?.verified || false;
                  }
                  if (prevsectionIndex >= 0) {
                    prevSectionVerified = prevsectionIndex !== "" ? prevData_[prevsectionIndex]?.verified || false : false;
                  }
                  if (prevData_.length === 0 && mIndex === 0) {
                    prevSectionVerified = true;
                  } else if (mIndex === 0 && prevSectionVerified === false) {
                    prevSectionVerified = true;
                  } else if (prevSectionVerified === true && !currentVerified) {
                    prevSectionVerified = true;
                  }

                  if (prevSectionVerified) {
                    return (
                      <div className="row" key={mIndex}>
                        <div className="col-lg-12">
                          <div className="card">
                            <div className="card-body">
                              <div className="panel-group1" id="accordion1">
                                <div className="panel panel-default mb-4">
                                  <div className="panel-heading1 ">
                                    <h4 className="panel-title1">
                                      <a className="accordion-toggle collapsed" data-bs-toggle="collapse" data-bs-parent="#accordion" href={`#collapse${parseInt(mIndex) + 1}`} aria-expanded="false">
                                        {currentVerified && (
                                          <span>
                                            <i class="fa fa-check-circle" aria-hidden="true" style={{ color: "#FFF", marginRight: "10px", fontSize: "20px" }}></i>
                                          </span>
                                        )}
                                        {(item.title!=="" && item.title!==null)?showHTMLText(item.title):'' }
                                      </a>
                                    </h4>
                                  </div>

                                  <div id={`collapse${parseInt(mIndex) + 1}`} className="panel-collapse collapse" role="tabpanel">
                                    <table className="table border table-bordered mb-0">
                                      <tbody>
                                        {item.questions.map((qItem, index) => {
                                          let existQuestion = "";
                                          let updatedData = [...prevData_];
                                          /* let currentApproved = false; */
                                          if (sectionIndex !== -1) {
                                            // section exists
                                            const section = updatedData[sectionIndex];
                                            /* currentApproved = section?.verified || false; */

                                            // get previous section verified status
                                            if (sectionIndex > 0) {
                                              prevSectionVerified = prevData_[sectionIndex - 1]?.verified || false;
                                            }

                                            const questionIndex = section.questions.findIndex((q) => q.id === qItem.id);
                                            if (questionIndex !== -1) {
                                              // question exists → update
                                              existQuestion = {
                                                ...section.questions[questionIndex],
                                              };
                                            }
                                          }

                                          return (
                                            <tr className={qItem?.error ? "text-danger bg-danger-transparent" : ""} key={index}>
                                              <td>{parseInt(index) + 1}</td>
                                              <td>{(qItem.title!=="" && qItem.title!==null)?showHTMLText(qItem.title):'' }</td>
                                              <td style={{ width: "150px" }}>
                                                {currentCompletd ? (
                                                  existQuestion?.available
                                                ) : (
                                                  <div className="custom-controls d-flex gap-3">
                                                    <label className="custom-control custom-radio-md mb-0">
                                                      <input
                                                        type="radio"
                                                        className="custom-control-input"
                                                        name={`avail_${item.id}_${qItem.id}`}
                                                        value="yes"
                                                        onChange={this.handleRadioChange.bind(this, item.id, qItem.id, "Yes")}
                                                        checked={existQuestion?.available === "Yes" ? true : false}
                                                      />
                                                      <span className="custom-control-label">Yes</span>
                                                    </label>

                                                    <label className="custom-control custom-radio-md mb-0">
                                                      <input
                                                        type="radio"
                                                        className="custom-control-input"
                                                        name={`avail_${item.id}_${qItem.id}`}
                                                        value="no"
                                                        onChange={this.handleRadioChange.bind(this, item.id, qItem.id, "No")}
                                                        checked={existQuestion?.available === "No" ? true : false}
                                                      />
                                                      <span className="custom-control-label">No</span>
                                                    </label>
                                                  </div>
                                                )}
                                              </td>
                                              <td style={{ width: "250px" }}>
                                                {currentCompletd ? (
                                                  existQuestion?.remarks || ""
                                                ) : (
                                                  <input
                                                    type="text"
                                                    className="form-control upper-case"
                                                    placeholder="Remarks"
                                                    onChange={this.handleTextChange.bind(this, item.id, qItem.id)}
                                                    value={existQuestion?.remarks || ""}
                                                    disabled={existQuestion?.available === "Yes" || existQuestion === "" ? true : false}
                                                  />
                                                )}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                        {currentCompletd &&
                                          (currentVerified ? (
                                            <tr>
                                              <td colSpan={4}>
                                                <b>Verified</b>, Verified By: <b>{prevData_[sectionIndex]?.verifiedByName}</b> Date:<b>{showDateTime(prevData_[sectionIndex]?.verifiedDate || "")}</b>
                                              </td>
                                            </tr>
                                          ) : (
                                            <tr className={item?.error ? "text-danger bg-danger-transparent" : ""}>
                                              <td colSpan={4}>
                                                <div className="custom-controls-stacked">
                                                  <label className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input" name="example-checkbox1" value="option1" onChange={this.handleVerify.bind(this, item.id)} />
                                                    <span className="custom-control-label">Verify</span>
                                                  </label>
                                                </div>
                                              </td>
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  } else {
                    return "";
                  }
                })}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closePopup.bind(this)}>
                  Close
                </button>
                {this.state.prejoinCurrent !== 12 && (
                  <>
                    {[2, 5, 8, 11].indexOf(this.state.prejoinCurrent) < 0 && (
                      <button className="btn btn-info" id="saveJoinForm" type="button" onClick={this.savePrejoinForm.bind(this, "save")}>
                        Save changes
                      </button>
                    )}

                    <button className="btn btn-primary" id="saveJoinForm" type="button" onClick={this.savePrejoinForm.bind(this, "complete")}>
                      {[2, 5, 8, 11].indexOf(this.state.prejoinCurrent) >= 0 ? `Confirm to Verify` : `Save & Complete`}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="salarymodal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Salary Details</h5>
                <button className="btn-close" id="salaryModalClose" data-bs-dismiss="modal" aria-label="Close" onClick={this.closeSalaryPopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-row">
                  <div className="form-group col-md-3">
                    <label className="form-label">
                      Basic Wages<span className="lbl-error">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control upper-case${this.state.salaryErrors.BasicWages ? " is-invalid" : ""}`}
                      placeholder="Enter Basic Wages"
                      value={this.state.salaryData.BasicWages}
                      onChange={(e) => this.handleSalaryChange("BasicWages", e.target.value)}
                    />
                    {this.state.salaryErrors.BasicWages && <span className="error">{this.state.salaryErrors.BasicWages}</span>}
                  </div>
                  <div className="form-group col-md-3">
                    <label className="form-label">Fixed Overtime Allowance</label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Enter Overtime Wages"
                      value={this.state.salaryData.OvertimeWages}
                      onChange={(e) => this.handleSalaryChange("OvertimeWages", e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label className="form-label">Shipboard Allowance</label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Enter Shipboard Allowance"
                      value={this.state.salaryData.ShipboardAlawance}
                      onChange={(e) => this.handleSalaryChange("ShipboardAlawance", e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label className="form-label">Earned Leave Wage</label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Enter Leave Wages"
                      value={this.state.salaryData.LeaveWages}
                      onChange={(e) => this.handleSalaryChange("LeaveWages", e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label className="form-label">Leave Subsistence Allowance</label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Enter Leave Subsistence"
                      value={this.state.salaryData.LeaveSubsistence}
                      onChange={(e) => this.handleSalaryChange("LeaveSubsistence", e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label className="form-label">Uniform Allowance</label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Enter Uniform Allowance"
                      value={this.state.salaryData.UniformAllowance}
                      onChange={(e) => this.handleSalaryChange("UniformAllowance", e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label className="form-label">Owners Special Allowance</label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Enter Owners Special Allowance"
                      value={this.state.salaryData.OwnersSpecialallowance}
                      onChange={(e) => this.handleSalaryChange("OwnersSpecialallowance", e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label className="form-label">Miscellaneous Allowance</label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Enter Miscellaneous Allowance"
                      value={this.state.salaryData.MiscellaneousAllowance}
                      onChange={(e) => this.handleSalaryChange("MiscellaneousAllowance", e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label className="form-label">Other Allowance</label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Enter Other Allowance"
                      value={this.state.salaryData.OtherAllowance}
                      onChange={(e) => this.handleSalaryChange("OtherAllowance", e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label className="form-label">Employer - PF</label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Enter Emloyer - PF"
                      value={this.state.salaryData.EmloyerPF}
                      onChange={(e) => this.handleSalaryChange("EmloyerPF", e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label className="form-label">Employee - PF</label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Enter Employee - PF"
                      value={this.state.salaryData.EmployeePF}
                      onChange={(e) => this.handleSalaryChange("EmployeePF", e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closeSalaryPopup.bind(this)}>
                  Close
                </button>
                <button className="btn btn-primary" id="submit_salary_frm" type="button" onClick={this.saveSalary}>
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default List;

function validationConfig(props) {
  const { rank, company, vslName, vesselType, sign_on_port, sign_on, wage_start, eoc, wages, currency, wages_types } = props.fields;

  return {
    fields: ["rank", "company", "vslName", "vesselType", "sign_on_port", "sign_on", "wage_start", "eoc", "wages", "currency", "wages_types"],
    validations: {
      rank: [[isSingleSelect, rank]],
      company: [[isSingleSelect, company]],
      vslName: [[isSingleSelect, vslName]],
      vesselType: [[isSingleSelect, vesselType]],
      sign_on_port: [[isSingleSelect, sign_on_port]],
      sign_on: [[isEmpty, sign_on]],
      wage_start: [[isEmpty, wage_start]],
      eoc: [[isEmpty, eoc]],
      wages: [[isEmpty, wages]],
      currency: [[isSingleSelect, currency]],
      wages_types: [[isSingleSelect, wages_types]],
    },
  };
}
class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPDF: false,
      restData: false,
      pdfName: "",
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.restForm === true) {
      this.props.sateValChange("restForm", false);
      setTimeout(() => {
        this.handleReset();
      }, 1000);
    }
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeFile(name, value) {
    this.props.onChange(name, value);
  }
  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      this.props.onChange("document_files", previewUrl);
    }
  };
  viewFile(pdfName,  e) {
    e.preventDefault();
    window.open(`${s3Link}contract/${pdfName}`, '_blank');
    //this.setState({ showPDF: !this.state.showPDF, pdfName });
  }
  closeFile(e) {
    e.preventDefault();
    this.setState({ showPDF: !this.state.showPDF, pdfName: "" });
  }
  closePopup() {
    this.props.sateValChange("restForm", true);
  }
  handleReset = () => {
    const { $validation } = this.props;
    // 2️⃣ Reset all validation errors
    Object.keys($validation).forEach((key) => {
      if ($validation[key]) {
        $validation[key].show = false;
        $validation[key].error = {};
      }
    });
    this.setState({ restData: this.state.restData });
  };

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgrank,
      errMsgcompany,
      errMsgvslName,
      errMsgvesselType,
      errMsgsign_on_port,
      errMsgsign_on,
      errMsgwage_start,
      errMsgeoc,
      errMsgwages,
      errMsgcurrency,
      errMsgwages_types = "";
    if ($validation.rank.error.reason !== undefined) {
      errMsgrank = $validation.rank.show && <span className="error">{$validation.rank.error.reason}</span>;
    }
    if ($validation.company.error.reason !== undefined) {
      errMsgcompany = $validation.company.show && <span className="error">{$validation.company.error.reason}</span>;
    }
    if ($validation.vslName.error.reason !== undefined) {
      errMsgvslName = $validation.vslName.show && <span className="error">{$validation.vslName.error.reason}</span>;
    }
    if ($validation.vesselType.error.reason !== undefined) {
      errMsgvesselType = $validation.vesselType.show && <span className="error">{$validation.vesselType.error.reason}</span>;
    }
    if ($validation.sign_on_port.error.reason !== undefined) {
      errMsgsign_on_port = $validation.sign_on_port.show && <span className="error">{$validation.sign_on_port.error.reason}</span>;
    }
    if ($validation.sign_on.error.reason !== undefined) {
      errMsgsign_on = $validation.sign_on.show && <span className="error">{$validation.sign_on.error.reason}</span>;
    }
    if ($validation.wage_start.error.reason !== undefined) {
      errMsgwage_start = $validation.wage_start.show && <span className="error">{$validation.wage_start.error.reason}</span>;
    }
    if ($validation.eoc.error.reason !== undefined) {
      errMsgeoc = $validation.eoc.show && <span className="error">{$validation.eoc.error.reason}</span>;
    }
    if ($validation.wages.error.reason !== undefined) {
      errMsgwages = $validation.wages.show && <span className="error">{$validation.wages.error.reason}</span>;
    }
    if ($validation.currency.error.reason !== undefined) {
      errMsgcurrency = $validation.currency.show && <span className="error">{$validation.currency.error.reason}</span>;
    }
    if ($validation.wages_types.error.reason !== undefined) {
      errMsgwages_types = $validation.wages_types.show && <span className="error">{$validation.wages_types.error.reason}</span>;
    }

    return (
      <>
        <div style={{ display: !this.state.showPDF ? "none" : "" }}>
          {this.state.showPDF && <iframe src={`${s3Link}contract/${this.state.pdfName}`} width="100%" height="500px" title="View Doc"></iframe>}
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={this.closeFile.bind(this)}>
              Back
            </button>
          </div>
        </div>
        <div style={{ display: this.state.showPDF ? "none" : "" }}>
          <div className="modal-body">
            <div className="form-group">
              <div className="form-row">
                <div className="form-group col-md-4">
                  <label className="form-label">
                    Rank<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.rank} onChange={this.handleSelectChange.bind(this, "rank")} placeholder="Select Rank" isClearable={true} options={this.props.rankList} />
                  {errMsgrank}
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">
                    Company<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.company} onChange={this.handleSelectChange.bind(this, "company")} placeholder="Select Company" isClearable={true} options={this.props.companyList} />
                  {errMsgcompany}
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">
                    Vessel<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.vslName} onChange={this.handleSelectChange.bind(this, "vslName")} placeholder="Select Vessel" isClearable={true} options={this.props.vesselList} />
                  {errMsgvslName}
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">
                    Vessel Type<span className="lbl-error">*</span>
                  </label>
                  <Select
                    value={fields.vesselType}
                    onChange={this.handleSelectChange.bind(this, "vesselType")}
                    placeholder="Select Vessel Type"
                    isClearable={true}
                    options={this.props.vessleTypeList}
                  />
                  {errMsgvesselType}
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">
                    Sign On Port<span className="lbl-error">*</span>
                  </label>
                  <Select
                    value={fields.sign_on_port}
                    onChange={this.handleSelectChange.bind(this, "sign_on_port")}
                    placeholder="Select Sign On Port"
                    isClearable={true}
                    options={this.props.portList}
                  />
                  {errMsgsign_on_port}
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">
                    Sign ON Date<span className="lbl-error">*</span>
                  </label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select Sign ON Date"
                    className="form-control"
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.sign_on}
                    dateFormat="dd-MM-yyyy"
                    isClearable
                    onChange={this.handleSelectChange.bind(this, "sign_on")}
                  />
                  {errMsgsign_on}
                </div>
                {this.props.editID !== "" && fields.contractPrejoinCurrent >= 6 && (
                  <div className="form-group col-md-4">
                    <label className="form-label">Sign ON DG Date</label>
                    <DatePicker
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      placeholderText="Select Sign ON DG Date"
                      className="form-control"
                      onKeyDown={(e) => e.preventDefault()}
                      selected={fields.sign_on_dg}
                      dateFormat="dd-MM-yyyy"
                      isClearable
                      onChange={this.handleSelectChange.bind(this, "sign_on_dg")}
                    />
                  </div>
                )}
                <div className="form-group col-md-4">
                  <label className="form-label">EOC</label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select EOC"
                    className="form-control"
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.eoc}
                    dateFormat="dd-MM-yyyy"
                    isClearable
                    onChange={this.handleSelectChange.bind(this, "eoc")}
                  />
                  {errMsgeoc}
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">
                    Wages start<span className="lbl-error">*</span>
                  </label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select Wages start"
                    className="form-control"
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.wage_start}
                    dateFormat="dd-MM-yyyy"
                    isClearable
                    minDate={fields.sign_on !== "" ? fields.sign_on : ""}
                    onChange={this.handleSelectChange.bind(this, "wage_start")}
                  />
                  {errMsgwage_start}
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">Wages</label>
                  <input type="text" className="form-control upper-case" placeholder="Wages" name="wages" value={fields.wages} {...$field("wages", (e) => onChange("wages", e.target.value))} />
                  {errMsgwages}
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">
                    Currency<span className="lbl-error">*</span>
                  </label>
                  <Select
                    value={fields.currency}
                    onChange={this.handleSelectChange.bind(this, "currency")}
                    placeholder="Select Currency"
                    isClearable={true}
                    options={[
                      { label: "AED", value: "AED" },
                      { label: "BMD", value: "BMD" },
                      { label: "EUR", value: "EUR" },
                      { label: "GBP", value: "GBP" },
                      { label: "INR", value: "INR" },
                      { label: "MYR", value: "MYR" },
                      { label: "SGD", value: "SGD" },
                      { label: "USD", value: "USD" },
                    ]}
                  />
                  {errMsgcurrency}
                </div>
                <div className="form-group col-md-4">
                  <label className="form-label">
                    Wages Type<span className="lbl-error">*</span>
                  </label>
                  <Select
                    value={fields.wages_types}
                    onChange={this.handleSelectChange.bind(this, "wages_types")}
                    placeholder="Select Wages Type"
                    isClearable={true}
                    options={[
                      { label: "Nett", value: "Nett" },
                      { label: "Gross", value: "Gross" },
                      { label: "Per Day", value: "Per Day" },
                      { label: "Per Month", value: "Per Month" },
                    ]}
                  />
                  {errMsgwages_types}
                </div>

                {this.props.editID !== "" && (
                  <>
                    {fields.contractPrejoinCurrent >= 3 && (
                      <>
                        <div className="form-group col-md-4">
                          <label className="form-label">Emigrate Number</label>
                          <input
                            type="text"
                            className="form-control upper-case"
                            placeholder="Emigrate Number"
                            name="emigrate_number"
                            value={fields.emigrate_number}
                            {...$field("emigrate_number", (e) => onChange("emigrate_number", e.target.value))}
                          />
                        </div>
                        <div className="form-group col-md-4">
                          <label className="form-label">AOA Number</label>
                          <input
                            type="text"
                            className="form-control upper-case"
                            placeholder="AOA Number"
                            name="aoa_number"
                            value={fields.aoa_number}
                            {...$field("aoa_number", (e) => onChange("aoa_number", e.target.value))}
                          />
                        </div>
                      </>
                    )}
                    {fields.contractPrejoinCurrent >= 9 && (
                      <>
                        <div className="form-group col-md-4">
                          <label className="form-label">Sign off</label>
                          <DatePicker
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText="Select Sign off"
                            className="form-control"
                            onKeyDown={(e) => e.preventDefault()}
                            selected={fields.sign_off}
                            dateFormat="dd-MM-yyyy"
                            isClearable
                            minDate={fields.sign_on !== "" ? addDays(new Date(fields.sign_on), 1) : ""}
                            maxDate={new Date()}
                            onChange={this.handleSelectChange.bind(this, "sign_off")}
                          />
                          {console.log(fields.sign_on)}
                        </div>
                        <div className="form-group col-md-4">
                          <label className="form-label">Sign off(DG)</label>
                          <DatePicker
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText="Select Sign off(DG)"
                            className="form-control"
                            onKeyDown={(e) => e.preventDefault()}
                            selected={fields.sign_off_dg}
                            dateFormat="dd-MM-yyyy"
                            isClearable
                            minDate={fields.sign_on !== "" ? addDays(new Date(fields.sign_on), 1) : ""}
                            maxDate={new Date()}
                            onChange={this.handleSelectChange.bind(this, "sign_off_dg")}
                          />
                        </div>
                        <div className="form-group col-md-4">
                          <label className="form-label">Sign OFF Port</label>
                          <Select
                            value={fields.sign_off_port}
                            onChange={this.handleSelectChange.bind(this, "sign_off_port")}
                            placeholder="Select Sign OFF Port"
                            isClearable={true}
                            options={this.props.portList}
                          />
                        </div>
                        <div className="form-group col-md-4">
                          <label className="form-label">Reason for Sign OFF</label>
                          <input
                            type="text"
                            className="form-control upper-case"
                            placeholder="Reason for Sign OFF"
                            name="reason_for_sign_off"
                            value={fields.reason_for_sign_off}
                            {...$field("reason_for_sign_off", (e) => onChange("reason_for_sign_off", e.target.value))}
                          />
                        </div>
                        <div className="form-group col-md-4">
                          <label className="form-label">Contract Extension</label>
                          <Select
                            value={fields.contractExtension}
                            onChange={this.handleSelectChange.bind(this, "contractExtension")}
                            placeholder="Select Contract Extension"
                            isClearable={true}
                            options={[
                              { label: "Yes", value: "Yes" },
                              { label: "No", value: "No" },
                            ]}
                          />
                        </div>
                        {fields.contractExtension?.value === "Yes" && (
                          <>
                            <div className="form-group col-md-4">
                              <label className="form-label">Rev/Ext</label>
                              <Select
                                value={fields.contractRevisionCategory}
                                onChange={this.handleSelectChange.bind(this, "contractRevisionCategory")}
                                placeholder="Select Rev/Ext"
                                isClearable={true}
                                options={[
                                  { label: "Revision", value: "Revision" },
                                  { label: "Extension", value: "Extension" },
                                ]}
                              />
                            </div>
                            <div className="form-group col-md-4">
                              <label className="form-label">Requested By</label>
                              <Select
                                value={fields.contractRevisionRequestedBy}
                                onChange={this.handleSelectChange.bind(this, "contractRevisionRequestedBy")}
                                placeholder="Select Requested By"
                                isClearable={true}
                                options={[
                                  { label: "Owners", value: "Owners" },
                                  { label: "Candidate", value: "Candidate" },
                                ]}
                              />
                            </div>
                            <div className="form-group col-md-4">
                              <label className="form-label">Extension Date</label>
                              <DatePicker
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText="Select Extension Date"
                                className="form-control"
                                onKeyDown={(e) => e.preventDefault()}
                                selected={fields.contractExtensionDate}
                                dateFormat="dd-MM-yyyy"
                                isClearable={fields.contractExtensionDate !== "" ? true : false}
                                minDate={fields.eoc !== "" ? addDays(new Date(fields.eoc), 1) : ""}
                                onChange={this.handleSelectChange.bind(this, "contractExtensionDate")}
                              />
                            </div>
                            <div className="form-group col-md-4">
                              <label className="form-label">Contract Extension Days</label>
                              <input
                                type="text"
                                className="form-control upper-case"
                                placeholder="Contract Extension Days"
                                name="contractExtensionDays"
                                readOnly={true}
                                value={fields.contractExtensionDays}
                              />
                            </div>
                            <div className="form-group col-md-4">
                              <label className="form-label">Remakrs</label>
                              <input
                                type="text"
                                className="form-control upper-case"
                                placeholder="Remakrs"
                                name="contractRevisionRemarks"
                                value={fields.contractRevisionRemarks}
                                {...$field("contractRevisionRemarks", (e) => onChange("contractRevisionRemarks", e.target.value))}
                              />
                            </div>
                          </>
                        )}
                      </>
                    )}
                    {fields.contractPrejoinCurrent >= 3 && (
                      <div class="card">
                        <div class="card-header bg-primary text-white">Documents</div>

                        <div class="card-body">
                          <div class="row g-4">
                            {fields.contractPrejoinCurrent >= 3 && (
                              <>
                                <div class="col-xl-4 col-md-6">
                                  <div class="border rounded p-3 text-center">
                                    <h6 class="mb-3">Contract</h6>

                                    <input type="file" class="form-control mb-3" id="contract_document" accept="application/pdf" onChange={this.handleFileChange} />
                                    {fields.contract_document !== "" && (
                                      <a href="/" onClick={this.viewFile.bind(this, fields.contract_document)}>
                                        <button class="btn btn-outline-secondary btn-sm ms-2">View</button>
                                      </a>
                                    )}
                                  </div>
                                </div>

                                <div class="col-xl-4 col-md-6">
                                  <div class="border rounded p-3 text-center">
                                    <h6 class="mb-3">AOA Document</h6>

                                    <input type="file" class="form-control mb-3" id="contract_aoa" accept="application/pdf" onChange={this.handleFileChange} />
                                    {fields.contract_aoa !== "" && (
                                      <a href="/" onClick={this.viewFile.bind(this, fields.contract_aoa)}>
                                        <button class="btn btn-outline-secondary btn-sm ms-2">View</button>
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                            {fields.contractPrejoinCurrent >= 6 && (
                              <div class="col-xl-4 col-md-6">
                                <div class="border rounded p-3 text-center">
                                  <h6 class="mb-3">Upload ”DG FORM-1-S/On"</h6>

                                  <input type="file" class="form-control mb-3" id="sign_on_dg_file" accept="application/pdf" onChange={this.handleFileChange} />
                                  {fields.sign_on_dg_file !== "" && (
                                    <a href="/" onClick={this.viewFile.bind(this, fields.sign_on_dg_file)}>
                                      <button class="btn btn-outline-secondary btn-sm ms-2">View</button>
                                    </a>
                                  )}
                                </div>
                              </div>
                            )}
                            {fields.contractPrejoinCurrent >= 9 && (
                              <>
                                <div class="col-xl-4 col-md-6">
                                  <div class="border rounded p-3 text-center">
                                    <h6 class="mb-3">Upload ”DG FORM-1-S/OFF"</h6>

                                    <input type="file" class="form-control mb-3" id="sign_off_dg_file" accept="application/pdf" onChange={this.handleFileChange} />
                                    {fields.sign_off_dg_file !== "" && (
                                      <a href="/" onClick={this.viewFile.bind(this, fields.sign_off_dg_file)}>
                                        <button class="btn btn-outline-secondary btn-sm ms-2">View</button>
                                      </a>
                                    )}
                                  </div>
                                </div>

                                <div class="col-xl-4 col-md-6">
                                  <div class="border rounded p-3 text-center">
                                    <h6 class="mb-3">If Contract Extension Upload Revised COE</h6>

                                    <input type="file" class="form-control mb-3" id="contractExtensionFile" accept="application/pdf" onChange={this.handleFileChange} />
                                    {fields.contractExtensionFile !== "" && (
                                      <a href="/" onClick={this.viewFile.bind(this, fields.contractExtensionFile)}>
                                        <button class="btn btn-outline-secondary btn-sm ms-2">View</button>
                                      </a>
                                    )}
                                  </div>
                                </div>

                                <div class="col-xl-4 col-md-6">
                                  <div class="border rounded p-3 text-center">
                                    <h6 class="mb-3">KARCO Test Certificate</h6>

                                    <input type="file" class="form-control mb-3" id="contractKARCOCertificate" accept="application/pdf" onChange={this.handleFileChange} />
                                    {fields.contractKARCOCertificate !== "" && (
                                      <a href="/" onClick={this.viewFile.bind(this, fields.contractKARCOCertificate)}>
                                        <button class="btn btn-outline-secondary btn-sm ms-2">View</button>
                                      </a>
                                    )}
                                  </div>
                                </div>

                                <div class="col-xl-4 col-md-6">
                                  <div class="border rounded p-3 text-center">
                                    <h6 class="mb-3">Upload Appraisal Report</h6>

                                    <input type="file" class="form-control mb-3" id="contractAppraisalReportFile" accept="application/pdf" onChange={this.handleFileChange} />
                                    {fields.contractAppraisalReportFile !== "" && (
                                      <a href="/" onClick={this.viewFile.bind(this, fields.contractAppraisalReportFile)}>
                                        <button class="btn btn-outline-secondary btn-sm ms-2">View</button>
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}

                            {fields.contractPrejoinCurrent >= 3 &&
                              formList.map((item, index) => {
                                return (
                                  <div class="col-xl-4 col-md-6" key={index}>
                                    <div class="border rounded p-3 text-center">
                                      <h6 class="mb-3">OFF-{item}</h6>

                                      <input type="file" class="form-control mb-3" id={`contractOff${item}`} accept="application/pdf" onChange={this.handleFileChange} />
                                      {fields[`contractOff${item}`] !== "" && (
                                        <a href="/" onClick={this.viewFile.bind(this, fields[`contractOff${item}`])}>
                                          <button class="btn btn-outline-secondary btn-sm ms-2">View</button>
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closePopup.bind(this)}>
              Close
            </button>
            <button
              className="btn btn-primary"
              id="submit_contract_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Save changes
            </button>
          </div>
        </div>
      </>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
